import type { FC, PropsWithChildren } from 'react';

export const CookieModalFooter: FC<PropsWithChildren> = ({ children }) => {
  /* render buttons in reverse order so that when we wrap on smaller screens the break happens on 1st, rather than last element.
     NOTE: requires `flex-direction: row-reverse|column-reverse` style be applied.
  */
  const cookieFooter = <div className="modal-footer">{children}</div>;
  return cookieFooter;
};
